import { render, staticRenderFns } from "./PscManager.ts.vue?vue&type=template&id=6b487d32&scoped=true&"
import script from "./PscManager.ts.vue?vue&type=script&lang=ts&"
export * from "./PscManager.ts.vue?vue&type=script&lang=ts&"
import style0 from "./PscManager.ts.vue?vue&type=style&index=0&id=6b487d32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b487d32",
  null
  
)

export default component.exports